<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-main>
      
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h4 class="text-md-h4 text-sm-body-2 text-lg-h4 font-weight-bold mb-3 text-uppercase text-center">Lista de Inscritos</h4>
          </v-responsive>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

             <v-row> 
                <v-col cols="12">
                    <v-text-field
                    v-model="search"
                    append-icon="mdi-search"
                    label="Busca:"
                    single-line
                    hide-details
                    outlined
                ></v-text-field>
                </v-col>
                
                <v-col cols="12">
                    <v-data-table
                        dense
                        :headers="headers"
                        :items="usuarios"
                        :items-per-page="20"
                        class="elevation-1"
                        :search="search"
                    ></v-data-table>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
              <h2 class="text-center">Exporte para csv</h2>
                </v-col>
          
                <v-col cols="12">
                    <v-list>
                        <v-list-item v-for="usuario of usuarios" :key="usuario.email">{{usuario.nome}},{{usuario.email}},{{usuario.cpf}}</v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-main>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    search: '',
    headers: [
        {
            text: 'Nome',
            align: 'start',
            sortable: true,
            value: 'nome',
        },
        { text: 'CPF', value: 'cpf' },
        { text: 'E-mail', value: 'email' },
        { text: 'Origem', value: 'origem' },
    ],
    
    usuarios: []
  }),

  async created() {
      try{
          this.$http.get('usuarios.json').then(
                res => {
                    for (const [key, value] of Object.entries(res.data)) {
                      var existe = false

                      for(var i=0; i< this.usuarios.length; i++){
                        var usuario = this.usuarios[i]
                        if(usuario.email == value.email){
                          existe = true
                        }
                      }
                      
                      if( existe == false ){
                        this.usuarios.push(
                          {
                              nome: value.nome.toUpperCase(),
                              email: value.email.toLowerCase(),
                              origem: value.origem,
                              cpf: value.cpf,
                              key: key
                          }
                        )
                      }
  
                    }
                    
                    this.ordenarNomes()

                    //Object.keys(res.data).forEach((key, value) => {
                    //  this.usuarios.push(value);
                    //});


                    // this.usuarios = res.data.filter( function( elem, index, array ) {
                    //     return array.indexOf( elem ) === index;
                    // } );


                    console.log(this.usuarios)


//                    this.usuarios = res.data
//                    this.ordenarNomes()
                    
                    // res.data.forEach(usuario => {
                    //     this.usuarios.push(
                    //         {
                    //             nome: usuario.nome,
                    //             email: usuario.email,
                    //             origem: usuario.origem,
                    //             cpf: usuario.cpf
                    //         }
                    //     )
                    // })
                }
            )        
      }catch(e){
          console.log("Houve erro: " + e)
      }
  },

  methods: {
    ordenarNomes(){
      console.log("chamando ordenarnomes")
      this.usuarios.sort(function(a, b){
                var nameA=a.nome.toLowerCase(), nameB=b.nome.toLowerCase()
                if (nameA < nameB) //sort string ascending
                    return -1 
                if (nameA > nameB)
                    return 1
                return 0 //default return value (no sorting)
            })
    }
  }
};
</script>
